console.log("IB-reset-password.js loaded");

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("reset_password");
  const emailInput = document.getElementById("RecoverEmail");

  if (!form) {
    console.warn("Reset form not found");
    return;
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const email = emailInput.value.trim().toLowerCase();
    if (!email) {
      showResetToast("Please enter your email.", "error");
      return;
    }

    const url =
  "https://microbiome-api-mjmpwq5lsa-ez.a.run.app/api/v1/recover_password";

try {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "accept": "application/json",
    },
    body: JSON.stringify({
      email: email,
      lang_code: "en",        // or dynamically detect language
      design: "default",      // change if needed
      is_shopify: true        // since this is Shopify
    })
  });


      // ----- HANDLE RATE LIMIT -----
      if (response.status === 429) {
        showResetToast("Too many attempts. Please try again later.", "error");
        return;
      }

      if (response.ok) {
        showResetToast("Password reset email sent!", "success");
        emailInput.value = "";
        window.location.hash = "login";
        return;
      }

      // ----- Other errors -----
      let err = null;
      try {
        err = await response.json();
      } catch (e) {}

      showResetToast(err?.detail || "Unable to send reset email.", "error");

    } catch (error) {
      showResetToast("Network error. Please try again.", "error");
    }
  });
});

function showResetToast(message, type = "success") {
  const toast = document.getElementById("ib-reset-toast");
  if (!toast) return;

  toast.innerText = message;
  toast.style.background = type === "success" ? "#2ecc71" : "#e74c3c";
  toast.style.display = "block";

  setTimeout(() => (toast.style.opacity = "1"), 10);

  setTimeout(() => {
    toast.style.opacity = "0";
    setTimeout(() => (toast.style.display = "none"), 300);
  }, 3000);
}
